var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 175",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_413_5754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 162.869L17.75 131.675C15.2958 130.254 13.3906 128.381 12.0344 126.056C10.6781 123.731 10 121.148 10 118.306V56.6938C10 53.8521 10.6781 51.2688 12.0344 48.9438C13.3906 46.6188 15.2958 44.7458 17.75 43.325L72 12.1312C74.4542 10.7104 77.0375 10 79.75 10C82.4625 10 85.0458 10.7104 87.5 12.1312L141.75 43.325C144.204 44.7458 146.109 46.6188 147.466 48.9438C148.822 51.2688 149.5 53.8521 149.5 56.6938V118.306C149.5 121.148 148.822 123.731 147.466 126.056C146.109 128.381 144.204 130.254 141.75 131.675L87.5 162.869C85.0458 164.29 82.4625 165 79.75 165C77.0375 165 74.4542 164.29 72 162.869Z",
    fill: "#1B4B86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_413_5754",
    x: 0,
    y: 0,
    width: 159.5,
    height: 175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_413_5754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_413_5754",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterTag);
export default __webpack_public_path__ + "static/media/register_tag.8847ec3caf72081d1d886f72e615de89.svg";
export { ForwardRef as ReactComponent };